// actions

import {
  APPOINTMENT_LIST_REQUEST,
  APPOINTMENT_LIST_SUCCESS,
  APPOINTMENT_LIST_FAIL,
  APPOINTMENT_DATA_REQUEST,
  APPOINTMENT_DATA_SUCCESS,
  APPOINTMENT_DATA_FAIL,
  APPOINTMENT_CREATE_REQUEST,
  APPOINTMENT_CREATE_SUCCESS,
  APPOINTMENT_CREATE_FAIL,
  APPOINTMENT_UPDATE_REQUEST,
  APPOINTMENT_UPDATE_SUCCESS,
  APPOINTMENT_UPDATE_FAIL,
  APPOINTMENT_DELETE_REQUEST,
  APPOINTMENT_DELETE_SUCCESS,
  APPOINTMENT_DELETE_FAIL,
  APPOINTMENT_SEARCH_REQUEST,
  APPOINTMENT_SEARCH_SUCCESS,
  APPOINTMENT_SEARCH_FAIL,
  APPOINTMENT_TYPE_LIST_REQUEST,
  APPOINTMENT_TYPE_LIST_SUCCESS,
  APPOINTMENT_TYPE_LIST_FAIL,
  APPOINTMENT_TYPE_DATA_REQUEST,
  APPOINTMENT_TYPE_DATA_SUCCESS,
  APPOINTMENT_TYPE_DATA_FAIL,
  APPOINTMENT_TYPE_CREATE_REQUEST,
  APPOINTMENT_TYPE_CREATE_SUCCESS,
  APPOINTMENT_TYPE_CREATE_FAIL,
  APPOINTMENT_TYPE_UPDATE_REQUEST,
  APPOINTMENT_TYPE_UPDATE_SUCCESS,
  APPOINTMENT_TYPE_UPDATE_FAIL,
  APPOINTMENT_TYPE_DELETE_REQUEST,
  APPOINTMENT_TYPE_DELETE_SUCCESS,
  APPOINTMENT_TYPE_DELETE_FAIL,
  APPOINTMENT_STATUS_LIST_REQUEST,
  APPOINTMENT_STATUS_LIST_SUCCESS,
  APPOINTMENT_STATUS_LIST_FAIL,
  APPOINTMENT_STATUS_DATA_REQUEST,
  APPOINTMENT_STATUS_DATA_SUCCESS,
  APPOINTMENT_STATUS_DATA_FAIL,
  APPOINTMENT_STATUS_CREATE_REQUEST,
  APPOINTMENT_STATUS_CREATE_SUCCESS,
  APPOINTMENT_STATUS_CREATE_FAIL,
  APPOINTMENT_STATUS_UPDATE_REQUEST,
  APPOINTMENT_STATUS_UPDATE_SUCCESS,
  APPOINTMENT_STATUS_UPDATE_FAIL,
  APPOINTMENT_STATUS_DELETE_REQUEST,
  APPOINTMENT_STATUS_DELETE_SUCCESS,
  APPOINTMENT_STATUS_DELETE_FAIL,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS,
  APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL,
} from "./actionType";

//Appointment List
export const appointmentListRequest = () => {
  return { type: APPOINTMENT_LIST_REQUEST };
};
export const appointmentListSuccess = (data) => {
  return { type: APPOINTMENT_LIST_SUCCESS, payload: data };
};
export const appointmentListFail = (error) => {
  return { type: APPOINTMENT_LIST_FAIL, payload: error };
};

//Appointment Data
export const appointmentDataRequest = (data) => {
  return { type: APPOINTMENT_DATA_REQUEST, payload: data };
};
export const appointmentDataSuccess = (data) => {
  return { type: APPOINTMENT_DATA_SUCCESS, payload: data };
};
export const appointmentDataFail = (error) => {
  return { type: APPOINTMENT_DATA_FAIL, payload: error };
};

//Appointment Create
export const appointmentCreateRequest = (data) => {
  return { type: APPOINTMENT_CREATE_REQUEST, payload: data };
};
export const appointmentCreateSuccess = (data) => {
  return { type: APPOINTMENT_CREATE_SUCCESS, payload: data };
};
export const appointmentCreateFail = (error) => {
  return { type: APPOINTMENT_CREATE_FAIL, payload: error };
};

//Appointment Update
export const appointmentUpdateRequest = (data) => {
  return { type: APPOINTMENT_UPDATE_REQUEST, payload: data };
};
export const appointmentUpdateSuccess = (data) => {
  return { type: APPOINTMENT_UPDATE_SUCCESS, payload: data };
};
export const appointmentUpdateFail = (error) => {
  return { type: APPOINTMENT_UPDATE_FAIL, payload: error };
};

//Appointment Delete
export const appointmentDeleteRequest = (data) => {
  return { type: APPOINTMENT_DELETE_REQUEST, payload: data };
};
export const appointmentDeleteSuccess = (data) => {
  return { type: APPOINTMENT_DELETE_SUCCESS, payload: data };
};
export const appointmentDeleteFail = (error) => {
  return { type: APPOINTMENT_DELETE_FAIL, payload: error };
};

//Appointment Search
export const appointmentSearchRequest = (data) => {
  return { type: APPOINTMENT_SEARCH_REQUEST, payload: data };
};
export const appointmentSearchSuccess = (data) => {
  return { type: APPOINTMENT_SEARCH_SUCCESS, payload: data };
};
export const appointmentSearchFail = (error) => {
  return { type: APPOINTMENT_SEARCH_FAIL, payload: error };
};

//Appointment Type List
export const appointmentTypeListRequest = () => {
  return { type: APPOINTMENT_TYPE_LIST_REQUEST };
};
export const appointmentTypeListSuccess = (data) => {
  return { type: APPOINTMENT_TYPE_LIST_SUCCESS, payload: data };
};
export const appointmentTypeListFail = (error) => {
  return { type: APPOINTMENT_TYPE_LIST_FAIL, payload: error };
};

//Appointment Type Data
export const appointmentTypeDataRequest = (data) => {
  return { type: APPOINTMENT_TYPE_DATA_REQUEST, payload: data };
};
export const appointmentTypeDataSuccess = (data) => {
  return { type: APPOINTMENT_TYPE_DATA_SUCCESS, payload: data };
};
export const appointmentTypeDataFail = (error) => {
  return { type: APPOINTMENT_TYPE_DATA_FAIL, payload: error };
};

//Appointment Type Create
export const appointmentTypeCreateRequest = (data) => {
  return { type: APPOINTMENT_TYPE_CREATE_REQUEST, payload: data };
};
export const appointmentTypeCreateSuccess = (data) => {
  return { type: APPOINTMENT_TYPE_CREATE_SUCCESS, payload: data };
};
export const appointmentTypeCreateFail = (error) => {
  return { type: APPOINTMENT_TYPE_CREATE_FAIL, payload: error };
};

//Appointment Type Update
export const appointmentTypeUpdateRequest = (data) => {
  return { type: APPOINTMENT_TYPE_UPDATE_REQUEST, payload: data };
};
export const appointmentTypeUpdateSuccess = (data) => {
  return { type: APPOINTMENT_TYPE_UPDATE_SUCCESS, payload: data };
};
export const appointmentTypeUpdateFail = (error) => {
  return { type: APPOINTMENT_TYPE_UPDATE_FAIL, payload: error };
};

//Appointment Type Delete
export const appointmentTypeDeleteRequest = (data) => {
  return { type: APPOINTMENT_TYPE_DELETE_REQUEST, payload: data };
};
export const appointmentTypeDeleteSuccess = (data) => {
  return { type: APPOINTMENT_TYPE_DELETE_SUCCESS, payload: data };
};
export const appointmentTypeDeleteFail = (error) => {
  return { type: APPOINTMENT_TYPE_DELETE_FAIL, payload: error };
};

//Appointment Status List
export const appointmentStatusListRequest = () => {
  return { type: APPOINTMENT_STATUS_LIST_REQUEST };
};
export const appointmentStatusListSuccess = (data) => {
  return { type: APPOINTMENT_STATUS_LIST_SUCCESS, payload: data };
};
export const appointmentStatusListFail = (error) => {
  return { type: APPOINTMENT_STATUS_LIST_FAIL, payload: error };
};

//Appointment Status Data
export const appointmentStatusDataRequest = (data) => {
  return { type: APPOINTMENT_STATUS_DATA_REQUEST, payload: data };
};
export const appointmentStatusDataSuccess = (data) => {
  return { type: APPOINTMENT_STATUS_DATA_SUCCESS, payload: data };
};
export const appointmentStatusDataFail = (error) => {
  return { type: APPOINTMENT_STATUS_DATA_FAIL, payload: error };
};

//Appointment Status Create
export const appointmentStatusCreateRequest = (data) => {
  return { type: APPOINTMENT_STATUS_CREATE_REQUEST, payload: data };
};
export const appointmentStatusCreateSuccess = (data) => {
  return { type: APPOINTMENT_STATUS_CREATE_SUCCESS, payload: data };
};
export const appointmentStatusCreateFail = (error) => {
  return { type: APPOINTMENT_STATUS_CREATE_FAIL, payload: error };
};

//Appointment Status Update
export const appointmentStatusUpdateRequest = (data) => {
  return { type: APPOINTMENT_STATUS_UPDATE_REQUEST, payload: data };
};
export const appointmentStatusUpdateSuccess = (data) => {
  return { type: APPOINTMENT_STATUS_UPDATE_SUCCESS, payload: data };
};
export const appointmentStatusUpdateFail = (error) => {
  return { type: APPOINTMENT_STATUS_UPDATE_FAIL, payload: error };
};

//Appointment Status Delete
export const appointmentStatusDeleteRequest = (data) => {
  return { type: APPOINTMENT_STATUS_DELETE_REQUEST, payload: data };
};
export const appointmentStatusDeleteSuccess = (data) => {
  return { type: APPOINTMENT_STATUS_DELETE_SUCCESS, payload: data };
};
export const appointmentStatusDeleteFail = (error) => {
  return { type: APPOINTMENT_STATUS_DELETE_FAIL, payload: error };
};

//Appointment Search Specific List
export const appointmentSearchSpecificListRequest = (data) => {
  return { type: APPOINTMENT_SEARCH_SPECIFIC_LIST_REQUEST, payload: data };
};
export const appointmentSearchSpecificListSuccess = (data) => {
  return { type: APPOINTMENT_SEARCH_SPECIFIC_LIST_SUCCESS, payload: data };
};
export const appointmentSearchSpecificListFail = (error) => {
  return { type: APPOINTMENT_SEARCH_SPECIFIC_LIST_FAIL, payload: error };
};
